import type { WithId } from '@octopus-do/octopus-project-core'
import { createAction } from '@reduxjs/toolkit'

export const MessagesActions = {
  viewed: createAction<WithId>('MESSAGES_VIEWED'),
}
